// libs
import React, { memo } from "react";
import styled from "@emotion/styled";

// constants
import { TEXTS } from "shared/components/AuthModal/constants";
import { BREAKPOINTS } from "shared/styles/base";

// styled components
const Container = styled.div`
    position: relative;
    display: flex;
    width: 94px;
    height: 270px;
    align-items: center;
    justify-content: center;
    margin-top: 116px;

    &:before {
        position: absolute;
        content: "";
        left: calc(50% - 2px);
        top: 0;
        bottom: 0;
        width: 2px;
        background: #ccc;
    }

    @media screen and (max-width: ${BREAKPOINTS.MOBILE}px) {
        width: 100%;
        height: 2px;
        margin-top: 40px;

        &:before {
            width: 100%;
            height: 2px;
            left: 0;
        }
    }

    .content {
        text-transform: uppercase;
        padding: 10px;
        color: #ccc;
        font-weight: 500;
        background: #fff;
        z-index: 2;
    }
`;

function Separator() {
    return (
        <Container>
            <div className="content">{TEXTS.OR}</div>
        </Container>
    );
}

export default memo(Separator);
